import { Box, Button, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

/** Right-anchored drawer paper fills viewport height. */
export const drawerPaperSx = {
  height: "100%",
};

export const ErrorAlertContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const ToolbarInviteButton = styled(Button)({
  textTransform: "none",
});

export const ToolbarClearFiltersButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  marginRight: theme.spacing(1),
}));

export const DrawerContentContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$drawerWidth",
})(({ theme, $drawerWidth }) => ({
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
  height: "100%",
  minHeight: 0,
  overflow: "hidden",
  padding: theme.spacing(2),
  width: $drawerWidth,
}));

export const DrawerHeader = styled(Stack)(({ theme }) => ({
  flexShrink: 0,
  marginBottom: theme.spacing(1),
}));

export const DetailDrawerHeaderStack = styled(Stack)({
  minWidth: 0,
});

export const DetailDrawerTitleRow = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  flexWrap: "wrap",
  gap: theme.spacing(2),
}));

export const DetailDrawerTitle = styled(Typography)({
  margin: 0,
  lineHeight: 1.3,
});

export const DetailDrawerStatusChipWrap = styled(Box)({
  display: "inline-flex",
  flexShrink: 0,
});

export const DetailDrawerSubtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
}));
